import React from "react";
import DetailDokumen from "../../components/organism/DetailOverviewDokumen";
const PageDetailDokumen = () => {
  return (
    <>
      <DetailDokumen />
    </>
  );
};

export default PageDetailDokumen;
